/**
 * @generated SignedSource<<b89eaa127b2b93da0272533c85e31ee5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubScannerDrawerQuery$variables = {
  hubName: string;
};
export type HubScannerDrawerQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly spaces: ReadonlyArray<{
        readonly frame: string;
        readonly id: string;
      }>;
    };
    readonly id: string;
    readonly name: string;
  } | null | undefined;
};
export type HubScannerDrawerQuery = {
  response: HubScannerDrawerQuery$data;
  variables: HubScannerDrawerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frame",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubScannerDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "kind": "RequiredField",
            "field": (v3/*:: as any*/),
            "action": "THROW"
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "HubScannerDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1599f3c00dd4aa2056b4aad2d52efcf7",
    "id": null,
    "metadata": {},
    "name": "HubScannerDrawerQuery",
    "operationKind": "query",
    "text": "query HubScannerDrawerQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    hub {\n      id\n      spaces {\n        id\n        frame\n      }\n    }\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "51be977b3f0e76cad6fd5a8276f63bb7";

export default node;
